import React from 'react';
import { Col, Card, CardBody } from 'reactstrap';
import MaterialIcon from 'material-icons-react';
import i18n from '../../../../i18next';
import { NavLink } from 'react-router-dom';
import { Link } from 'react-router-dom';

const DetailsCard = (props) => {
    const { screenTitleContainer, labelStyle, spanStyle, selectOrderStyle } = props.styles;

    return (
        <Col xs={6} sm={6} md={6}>
            <Col xs={6} style={screenTitleContainer}>
                <div><MaterialIcon icon={props.iconType} color="#0288d1" />{props.header}</div>
            </Col>
            <Card>
                <CardBody>
                    <p style={labelStyle}>{i18n.t('common:form.name')}: {props.nameLinkTo ? <NavLink tag={Link} to={props.nameLinkTo} style={{ padding: 5, ...selectOrderStyle }}> {props.name}</NavLink> : <span style={spanStyle}> {props.name}</span>}</p>
                    <p style={labelStyle}>{i18n.t('common:form.phone')}: <span style={spanStyle}> {props.phone}</span></p>
                    <p style={labelStyle}>{i18n.t('common:form.email')}: <span style={spanStyle}> {props.email}</span></p>
                    <p style={labelStyle}>{props.iconType === 'person' ? i18n.t('common:form.country') : i18n.t('common:form.address')}: <span style={spanStyle}> {props.location}</span></p>
                </CardBody>
            </Card>
        </Col>
    );
}

export default DetailsCard;


// WEBPACK FOOTER //
// ./src/components/restaurants/orders/orderDetailsCommon/DetailsCard.js